import { useCallback } from 'react';

import { useLockOrder, useUnlockOrder } from 'api/requests';
import { OrderEntity } from 'api/types/entity';
import { useServerErrorNotify } from 'hooks';

export const useLockAndUnlockOrder = (order: OrderEntity | null) => {
  const { lock, error: lockError } = useLockOrder();
  const { unlock } = useUnlockOrder();

  const lockOrderIfPossible = useCallback(async () => {
    if (!order?.id || order?.versionNumber === undefined) {
      return false;
    }

    try {
      const isLocked = await lock(order.id, order.versionNumber);
      return isLocked;
    } catch (error) {
      return false;
    }
  }, [lock, order?.id, order?.versionNumber]);

  const unlockOrder = useCallback(
    async () => unlock(order?.id!),
    [order?.id, unlock]
  );

  useServerErrorNotify(lockError);

  return { lockOrderIfPossible, unlockOrder };
};
